// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intro-section {
    position: relative;
    width: 100vw;
    min-height: 900px;
    text-align: center;
    margin: 0;
    padding: 20px;
    box-sizing: border-box;
}

.intro-video {
    width: 100vw;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}

.intro-text {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    min-height: 100%;
    color: white;
    padding: 0 20px;
    margin-top: 30vh;
}

.intro-text h1 {
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    line-height: 1.2;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
}

.flicker-text {
    display: inline-block;
    position: relative;
    min-width: 0;
    text-align: center;
    margin: 0 0.5rem;
}

.flicker-text::before {
    content: "see";
    display: inline-block;
    background: linear-gradient(90deg, #ffcc99, #ff9966, #ff66cc, #cc66ff);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    animation: flicker 6s infinite;
}

@keyframes flicker {
    0%, 16% { content: "see"; }
    16.01%, 32% { content: "measure"; }
    32.01%, 48% { content: "feel"; }
    48.01%, 64% { content: "compare"; }
    64.01%, 80% { content: "explore"; }
    80.01%, 100% { content: "visualize"; }
}

.button-group {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-bottom: 0.5rem;
}

.intro-cta-button {
    padding: 0.5rem 1.5rem;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: bold;
    color: #333;
    background: rgba(255, 255, 255, 0.8);
    cursor: pointer;
    transition: background 0.3s;
    min-width: 150px;
    min-height: 44px;
}

.intro-cta-button:hover {
    background: rgba(255, 255, 255, 1);
}

.book-demo-button {
    padding: 0.5rem 1.5rem;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: bold;
    color: white;
    background: linear-gradient(90deg, #ffcc99, #ff9966, #ff66cc, #cc66ff);
    cursor: pointer;
    transition: background 0.3s;
    min-width: 150px;
    min-height: 44px;
}

.book-demo-button:hover {
    background: linear-gradient(90deg, #cc66ff, #ff66cc, #ff9966, #ffcc99);
}

.intro-subtext {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
}

.underline {
    text-decoration: underline;
}

/* Responsive styles for mobile */
@media (max-width: 768px) {
    .intro-section {
        min-height: 100vh;
        padding: 15px;
    }

    .intro-text {
        margin-top: 30vh;
        padding: 0 15px;
    }

    .intro-text h1 {
        font-size: 1.8rem;
        margin-bottom: 0.75rem;
        line-height: 1.3;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
    }

    .button-group {
        flex-direction: column;
        gap: 0.75rem;
    }

    .intro-cta-button {
        padding: 0.5rem 1.5rem;
        font-size: 1rem;
        min-width: 200px;
        min-height: 48px;
    }

    .book-demo-button {
        padding: 0.5rem 1.5rem;
        font-size: 1rem;
        min-width: 200px;
        min-height: 48px;
    }

    .intro-subtext {
        font-size: 1.1rem;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
    }
}

@media (max-width: 480px) {
    .intro-section {
        min-height: 100vh;
        padding: 10px;
    }

    .intro-text {
        margin-top: 25vh;
        padding: 0 10px;
    }

    .intro-text h1 {
        font-size: 1.4rem;
        margin-bottom: 0.5rem;
        line-height: 1.4;
    }

    .intro-cta-button {
        padding: 0.4rem 1.2rem;
        font-size: 0.9rem;
        min-width: 180px;
        min-height: 44px;
    }

    .book-demo-button {
        padding: 0.4rem 1.2rem;
        font-size: 0.9rem;
        min-width: 180px;
        min-height: 44px;
    }

    .intro-subtext {
        font-size: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Css/HomePage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,sEAAsE;IACtE,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,UAAU,cAAc,EAAE;IAC1B,cAAc,kBAAkB,EAAE;IAClC,cAAc,eAAe,EAAE;IAC/B,cAAc,kBAAkB,EAAE;IAClC,cAAc,kBAAkB,EAAE;IAClC,eAAe,oBAAoB,EAAE;AACzC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,oCAAoC;IACpC,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,sEAAsE;IACtE,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,sEAAsE;AAC1E;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,iCAAiC;AACjC;IACI;QACI,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;QACtB,gBAAgB;QAChB,2CAA2C;IAC/C;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,2CAA2C;IAC/C;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".intro-section {\n    position: relative;\n    width: 100vw;\n    min-height: 900px;\n    text-align: center;\n    margin: 0;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n.intro-video {\n    width: 100vw;\n    height: 100%;\n    object-fit: cover;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n}\n\n.intro-text {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    min-height: 100%;\n    color: white;\n    padding: 0 20px;\n    margin-top: 30vh;\n}\n\n.intro-text h1 {\n    font-size: 2.5rem;\n    font-weight: bold;\n    margin-bottom: 1rem;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n    line-height: 1.2;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.flicker-text {\n    display: inline-block;\n    position: relative;\n    min-width: 0;\n    text-align: center;\n    margin: 0 0.5rem;\n}\n\n.flicker-text::before {\n    content: \"see\";\n    display: inline-block;\n    background: linear-gradient(90deg, #ffcc99, #ff9966, #ff66cc, #cc66ff);\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n    animation: flicker 6s infinite;\n}\n\n@keyframes flicker {\n    0%, 16% { content: \"see\"; }\n    16.01%, 32% { content: \"measure\"; }\n    32.01%, 48% { content: \"feel\"; }\n    48.01%, 64% { content: \"compare\"; }\n    64.01%, 80% { content: \"explore\"; }\n    80.01%, 100% { content: \"visualize\"; }\n}\n\n.button-group {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 0.5rem;\n}\n\n.intro-cta-button {\n    padding: 0.5rem 1.5rem;\n    border: none;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: bold;\n    color: #333;\n    background: rgba(255, 255, 255, 0.8);\n    cursor: pointer;\n    transition: background 0.3s;\n    min-width: 150px;\n    min-height: 44px;\n}\n\n.intro-cta-button:hover {\n    background: rgba(255, 255, 255, 1);\n}\n\n.book-demo-button {\n    padding: 0.5rem 1.5rem;\n    border: none;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: bold;\n    color: white;\n    background: linear-gradient(90deg, #ffcc99, #ff9966, #ff66cc, #cc66ff);\n    cursor: pointer;\n    transition: background 0.3s;\n    min-width: 150px;\n    min-height: 44px;\n}\n\n.book-demo-button:hover {\n    background: linear-gradient(90deg, #cc66ff, #ff66cc, #ff9966, #ffcc99);\n}\n\n.intro-subtext {\n    font-size: 1.2rem;\n    margin-bottom: 0.5rem;\n    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);\n}\n\n.underline {\n    text-decoration: underline;\n}\n\n/* Responsive styles for mobile */\n@media (max-width: 768px) {\n    .intro-section {\n        min-height: 100vh;\n        padding: 15px;\n    }\n\n    .intro-text {\n        margin-top: 30vh;\n        padding: 0 15px;\n    }\n\n    .intro-text h1 {\n        font-size: 1.8rem;\n        margin-bottom: 0.75rem;\n        line-height: 1.3;\n        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);\n    }\n\n    .button-group {\n        flex-direction: column;\n        gap: 0.75rem;\n    }\n\n    .intro-cta-button {\n        padding: 0.5rem 1.5rem;\n        font-size: 1rem;\n        min-width: 200px;\n        min-height: 48px;\n    }\n\n    .book-demo-button {\n        padding: 0.5rem 1.5rem;\n        font-size: 1rem;\n        min-width: 200px;\n        min-height: 48px;\n    }\n\n    .intro-subtext {\n        font-size: 1.1rem;\n        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);\n    }\n}\n\n@media (max-width: 480px) {\n    .intro-section {\n        min-height: 100vh;\n        padding: 10px;\n    }\n\n    .intro-text {\n        margin-top: 25vh;\n        padding: 0 10px;\n    }\n\n    .intro-text h1 {\n        font-size: 1.4rem;\n        margin-bottom: 0.5rem;\n        line-height: 1.4;\n    }\n\n    .intro-cta-button {\n        padding: 0.4rem 1.2rem;\n        font-size: 0.9rem;\n        min-width: 180px;\n        min-height: 44px;\n    }\n\n    .book-demo-button {\n        padding: 0.4rem 1.2rem;\n        font-size: 0.9rem;\n        min-width: 180px;\n        min-height: 44px;\n    }\n\n    .intro-subtext {\n        font-size: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
